export const CONTACT = {
  PHONE_NUMBER: "+62 87 779077 750",
  EMAIL: "support@lokasi.com"
};
